document.addEventListener('DOMContentLoaded', function () {
var copyButtons = document.querySelectorAll('[data-copy-article-link]');

copyButtons.forEach(function (button) {
    button.addEventListener('click', function () {
    var link = button.getAttribute('data-link');

    if (!link) return;

    navigator.clipboard
        .writeText(link)
        .then(function () {
        button.classList.add('is-copied');
        window.setTimeout(function () {
            button.classList.remove('is-copied');
        }, 1200);
        })
        .catch(function () {
        var fallbackInput = document.createElement('input');
        fallbackInput.value = link;
        document.body.appendChild(fallbackInput);
        fallbackInput.select();
        document.execCommand('copy');
        document.body.removeChild(fallbackInput);
        });
    });
});
});